import { faFacebookF, faInstagram, faLinkedinIn, faXTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { globalsSelector } from "store/globals";
import vars from "utils/vars";

const SocialNav = ({ variant, size, align, spacer = "", label = "" }) => {
	const { t } = useTranslation();
	const navLabel = label || t("titles.check_us_on_social_media");

	// redux global state
	const globals = useSelector(globalsSelector);

	return (
		<nav aria-label={navLabel}>
			<ul className={`list-inline mb-0 ${align}`}>
				{globals?.social_links?.facebook ? (
					<li className={`list-inline-item d-inline-flex align-items-center ${spacer && spacer}`}>
						<a
							className={`${variant ? `text-${variant}` : ""} ${size ? `fs-${size}` : ""}`}
							href={globals?.social_links?.facebook || vars.social.links.facebook}
							target="_blank"
							rel="noopener noreferrer"
							alt={t("titles.facebook")}
							aria-label={t("titles.facebook_link")}>
							<FontAwesomeIcon icon={faFacebookF} />
						</a>
					</li>
				) : (
					<></>
				)}
				{globals?.social_links?.twitter ? (
					<li className={`list-inline-item d-inline-flex align-items-center ${spacer && spacer}`}>
						<a
							className={`${variant ? `text-${variant}` : ""} ${size ? `fs-${size}` : ""}`}
							href={globals?.social_links?.twitter || vars.social.links.twitter}
							target="_blank"
							rel="noopener noreferrer"
							alt={t("titles.twitter")}
							aria-label={t("titles.twitter_link")}>
							<FontAwesomeIcon icon={faXTwitter} />
						</a>
					</li>
				) : (
					<></>
				)}
				{globals?.social_links?.linkedin ? (
					<li className={`list-inline-item d-inline-flex align-items-center ${spacer && spacer}`}>
						<a
							className={`${variant ? `text-${variant}` : ""} ${size ? `fs-${size}` : ""}`}
							href={globals?.social_links?.linkedin || vars.social.links.linkedIn}
							target="_blank"
							rel="noopener noreferrer"
							alt={t("titles.linkedin")}
							aria-label={t("titles.linkedin_link")}>
							<FontAwesomeIcon icon={faLinkedinIn} />
						</a>
					</li>
				) : (
					<></>
				)}
				{globals?.social_links?.youtube ? (
					<li className={`list-inline-item d-inline-flex align-items-center ${spacer && spacer}`}>
						<a
							className={`${variant ? `text-${variant}` : ""} ${size ? `fs-${size}` : ""}`}
							href={globals?.social_links?.youtube || vars.social.links.youtube}
							target="_blank"
							rel="noopener noreferrer"
							alt={t("titles.youtube")}
							aria-label={t("titles.youtube_link")}>
							<FontAwesomeIcon icon={faYoutube} />
						</a>
					</li>
				) : (
					<></>
				)}
				{globals?.social_links?.instagram ? (
					<li className={`list-inline-item d-inline-flex align-items-center ${spacer && spacer}`}>
						<a
							className={`${variant ? `text-${variant}` : ""} ${size ? `fs-${size}` : ""}`}
							href={globals?.social_links?.instagram || vars.social.links.instagram}
							target="_blank"
							rel="noopener noreferrer"
							alt={t("titles.instagram")}
							aria-label={t("titles.instagram_link")}>
							<FontAwesomeIcon icon={faInstagram} />
						</a>
					</li>
				) : (
					<></>
				)}
			</ul>
		</nav>
	);
};

export default memo(SocialNav);
